import { userApiClient } from "@/lib/userApiClient";

export interface WaitlistSubscribeParams {
  campaign_slug: string;
  email: string;
  name?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export interface WaitlistEntry {
  id: number;
  email: string;
  name: string | null;
  status: "pending" | "confirmed" | "unsubscribed";
  created_at: string;
}

export interface WaitlistSubscribeResponse {
  entry: WaitlistEntry;
  message: string;
  requires_confirmation: boolean;
}

export interface WaitlistUnsubscribeResponse {
  message: string;
  already_unsubscribed?: boolean;
}

export const waitlistService = {
  /**
   * 订阅 waitlist
   */
  async subscribe(
    params: WaitlistSubscribeParams
  ): Promise<WaitlistSubscribeResponse> {
    return userApiClient.post<WaitlistSubscribeResponse>(
      "/waitlist/subscribe",
      {
        waitlist: params,
      }
    );
  },

  /**
   * 退订
   */
  async unsubscribe(token: string): Promise<WaitlistUnsubscribeResponse> {
    return userApiClient.post<WaitlistUnsubscribeResponse>(
      `/waitlist/unsubscribe/${token}`
    );
  },

  /**
   * 重新发送确认邮件
   */
  async resendConfirmation(entryId: number): Promise<{ message: string }> {
    return userApiClient.post("/waitlist/resend_confirmation", {
      entry_id: entryId,
    });
  },
};
export default waitlistService;
